import React from 'react';

import { ReactComponent as WaytobillLogo } from 'assets/waytobill-logo.svg';
import { useAppContext, useLocaleContext } from 'context';
import { Typography } from 'kill-components';

import useStyles from './Footer.styles';

const Footer = () => {
  const { classes } = useStyles();

  const { merchantName } = useAppContext();
  const { translate } = useLocaleContext();

  return (
    <div className={classes.root}>
      <Typography
        align="center"
        className={classes.title}
        color="textSecondary"
        variant="caption"
      >
        {translate('footer', { merchant: merchantName })}
      </Typography>
      <WaytobillLogo />
    </div>
  );
};

export default Footer;
